import {
    MAX_NOTE_BODY_LENGTH,
    MAX_NOTE_TITLE_LENGTH
} from '../../components/patient/notes/noteAccess.ts';

export type ChartNoteIssue = 'too_long' | 'text_required';

export interface ChartNoteCheck {
    length: number;
    issue: ChartNoteIssue | null;
}

/** Mirrors the backend, which rejects a note whose trimmed plain text is empty or over the cap. */
export function checkChartNote(plainText: string, hasContent: boolean): ChartNoteCheck {
    const length = plainText.trim().length;
    if (length > MAX_NOTE_BODY_LENGTH) return { length, issue: 'too_long' };
    if (hasContent && length === 0) return { length, issue: 'text_required' };
    return { length, issue: null };
}

const ELLIPSIS = '…';

/** "Appointment: {reason} ({date})", with the reason shortened so the title fits MAX_NOTE_TITLE_LENGTH. */
export function buildAppointmentNoteTitle(
    reason: string | undefined,
    formattedDate: string
): string {
    const trimmedReason = reason?.trim();
    if (!trimmedReason) return `Appointment (${formattedDate})`;
    const title = `Appointment: ${trimmedReason} (${formattedDate})`;
    const overflow = title.length - MAX_NOTE_TITLE_LENGTH;
    if (overflow <= 0) return title;
    const shortReason = trimmedReason.slice(0, trimmedReason.length - overflow - ELLIPSIS.length);
    return `Appointment: ${shortReason.trimEnd()}${ELLIPSIS} (${formattedDate})`;
}
